import { ChangeDetectorRef, Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ResultType } from 'src/app/models/enums/result-type.enum';
import {
    AllowedItemChange,
    BreadcrumbData,
} from 'src/app/Modules/settings/components/settings-informate/components/instance-configuration/instance-configuration.component';
import { AllowedItem } from 'src/app/Modules/settings/models/informate/allowed-item';
import { AllowedItems } from 'src/app/Modules/settings/models/informate/allowed-items';
import { CustomToastService } from 'src/app/services/custom-toast.service';
import { IceapiService } from 'src/app/services/iceapi.service';
import { InstanceDataService } from 'src/app/services/instance-data.service';
import { UserUtilityService } from 'src/app/services/user-utility.service';
import { ConfirmationDialogComponent } from '../../../../../../shared/info-dialogs/confirmation-dialog/confirmation-dialog.component';
import { AppConstants } from 'src/app/constants/appconstants';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { NavigateUrlService } from 'src/app/services/navigateurl.service';
import { GlobalEmittersService } from 'src/app/services/global-emitters.service';

@Component({
    selector: 'app-instance-informate-configuration-settings',
    templateUrl: './instance-informate-configuration-settings.component.html',
    styleUrls: ['./instance-informate-configuration-settings.component.scss'],
    standalone: false,
})
export class InstanceInformateConfigurationSettingsComponent implements OnInit, OnDestroy {
    @Output() navigatetoNextWizard: EventEmitter<boolean> = new EventEmitter();
    destroy$ = new Subject();

    allowedItem: AllowedItems;
    selectedAllowedItemList: AllowedItem[];
    breadcrumbData: BreadcrumbData[];
    result: ResultType = ResultType.Error;
    isModified: boolean;
    isInformateInstance: boolean;
    instanceid: string;
    buttonText: string;
    selectAll: boolean = false;

    constructor(
        private iceSvc: IceapiService,
        private cd: ChangeDetectorRef,
        private customToastService: CustomToastService,
        private ngbModal: NgbModal,
        private route: ActivatedRoute,
        private ngxUiLoaderService: NgxUiLoaderService,
        private instanceDataService: InstanceDataService,
        private user_utility: UserUtilityService,
        private router: Router,
        private navigateUrlService: NavigateUrlService,
        private globalEmittersService: GlobalEmittersService,
    ) {
        this.isModified = false;
        this.buttonText = 'Next';
    }

    ngOnInit(): void {
        this.hadleSubcription();
    }

    hadleSubcription() {
        this.instanceDataService.instanceActiveTab.pipe(takeUntil(this.destroy$)).subscribe((res) => {
            if (res == AppConstants.tab_informate) {
                if (this.route.snapshot.paramMap.get('id')) {
                    this.instanceid = this.route.snapshot.paramMap.get('id');
                } else {
                    this.instanceid = this.instanceDataService.instanceDetails.instanceId;
                }
                this.getAlloweditems(this.instanceid);
            }
        });

        this.instanceDataService.isInformateInstance.pipe(takeUntil(this.destroy$)).subscribe((res) => {
            if (res) {
                this.isInformateInstance = res;
                this.buttonText = 'Save';
            } else {
                this.isInformateInstance = res;
                this.buttonText = 'Next';
            }
        });

        this.instanceDataService.instanceTabNext.pipe(takeUntil(this.destroy$)).subscribe((resp) => {
            if (resp == AppConstants.tab_informate) {
                this.saveInstanceSettings();
            }
        });

        this.instanceDataService.instanceTabBack.pipe(takeUntil(this.destroy$)).subscribe((resp) => {
            if (resp == AppConstants.tab_informate) {
                this.navigateBack();
            }
        });
    }

    async getAlloweditems(instanceid: any) {
        if (!this.allowedItem) {
            this.ngxUiLoaderService.start();
            await this.iceSvc
                .getAlloweditems(instanceid)
                .toPromise()
                .then(
                    (res) => {
                        if (res.success == true) {
                            this.ngxUiLoaderService.stop();
                            this.allowedItem = res.response;
                        } else {
                            this.user_utility.errorModelPopup(res.message);
                        }
                    },
                    (err) => {
                        this.ngxUiLoaderService.stop();
                    }
                );
            this.cd.markForCheck();
        }
    }

    //For allowedItemTypes
    allowedItemTypeHandler(allowedItemTypeId: string) {
        let layer = this.instanceDataService.currentLayer.getValue();
        this.selectedAllowedItemList = this.allowedItem.allowedItemTypes.find((x) => x.allowedItemTypeId == allowedItemTypeId).items;
        this.breadcrumbData = [
            { id: allowedItemTypeId, name: this.allowedItem.allowedItemTypes.find((x) => x.allowedItemTypeId == allowedItemTypeId).name, layer: layer },
        ];
        this.selectAll = false;
        this.instanceDataService.AllowedItemsselectAll.next(false);
        this.cd.detectChanges();
    }

    //For allowedItems
    allowedItemHandler(allowedItem: AllowedItem) {
        this.selectedAllowedItemList = allowedItem.items;
        this.updateBreadCrumb(allowedItem);
        this.selectAll = false;
        this.instanceDataService.AllowedItemsselectAll.next(false);
        this.cd.detectChanges();
    }

    //For breadCrumb click
    allowedItemBreadCrumbClickedHandler(data: BreadcrumbData) {
        // if (data.layer == 1) {
        this.instanceDataService.currentLayer.next(data.layer);
        this.instanceDataService.selectedBreadcrumbAllowedItems.next(data.id);
    }

    updateBreadCrumb(allowedItem: AllowedItem) {
        if (allowedItem.items) {
            let layer = this.instanceDataService.currentLayer.getValue();
            let _breadcrumbdata: BreadcrumbData[] = []; //.find(x => x.layer == layer)
            const index = this.breadcrumbData.findIndex((x) => x.layer === layer);
            if (index >= 0) {
                for (let i = 0; i < index; i++) {
                    _breadcrumbdata.push(this.breadcrumbData[i]);
                }
                _breadcrumbdata.push({ id: allowedItem.itemId, name: allowedItem.name, layer: layer });
                this.breadcrumbData = _breadcrumbdata;
            } else {
                this.breadcrumbData.push({ id: allowedItem.itemId, name: allowedItem.name, layer: layer });
            }
        }
    }

    dataChangeEventHandler(data: AllowedItemChange) {
        this.isModified = true;
        let selected: AllowedItem[];
        for (let i = 0; i < data.itemIds.length; i++) {
            if (i == 0) {
                selected = this.allowedItem.allowedItemTypes.find((x) => x.allowedItemTypeId == data.itemIds[i]).items;
            } else {
                if (selected.find((x) => x.itemId == data.itemIds[i])?.items != undefined) {
                    selected = selected.find((x) => x.itemId == data.itemIds[i])?.items; //[selected.find(x => x.itemId == data.itemIds[i])];
                } else {
                    selected = selected.filter((x) => x.itemId == data.itemIds[i]);
                }
            }
        }

        this.updateItems(selected, data);
    }

    async postAllowedItems(instanceId: any) {
        this.ngxUiLoaderService.start();
        this.result = await this.iceSvc.postAlloweditems(this.allowedItem, instanceId).toPromise();
        this.isModified = false;
        this.displayToast();
        this.ngxUiLoaderService.stop();
        this.getAlloweditems(this.instanceid);
        if (!this.isInformateInstance) {
            this.instanceDataService.instanceNavigationHandler(18);
        }
    }

    displayToast() {
        if (this.result == 1) {
            this.customToastService.successToast('Instance configuration updated successfully!', 'Success');
        } else {
            this.customToastService.errorToast('Error while updating the instance configuration!', 'Error');
        }
    }

    private updateItems(allowedItems: AllowedItem[], data: any) {
        for (let item of allowedItems) {
            if (item.items == undefined || item.items == null) {
                item.allowed = data.allowed;
            } else {
                item.allowed = data.allowed;
                this.updateItems(item.items, data);
            }
        }
    }

    postAllowedItemstoInformate(instanceid: any) {
        this.ngxUiLoaderService.start();
        this.iceSvc
            .postAlloweditems(this.allowedItem, instanceid)
            .toPromise()
            .then(
                (res) => {
                    this.ngxUiLoaderService.stop();
                    this.navigatetoNextWizard.emit(true);
                },
                (err) => {
                    this.ngxUiLoaderService.stop();
                }
            );
    }

    nevigateNextWizard() {
        const url = localStorage.getItem('selectedURL');
        this.router.navigate([url]);
        this.instanceDataService.navigateThroughWizard.next(8);
    }

    saveInstanceSettings() {
        if (this.isModified) {
            this.postAllowedItems(this.instanceid);
        } else {
            if (this.isInformateInstance && !this.isModified) {
                if (this.route.snapshot.paramMap.get('id')) {
                    this.customToastService.successToast('Instance data saved successfully!', 'Success');
                } else {
                    this.customToastService.successToast('Instance created successfully!', 'Success');
                    //this.router.navigate(['home']);
                }
                this.instanceDataService.instanceNavigationHandler(18);
            } else {
                this.instanceDataService.instanceNavigationHandler(18);
            }
        }

        if (!localStorage.getItem('currentInstanceName') && this.isInformateInstance) {
             this.globalEmittersService.currentInstanceId.next(this.instanceDataService.instanceDetails.instanceId);

            localStorage.setItem('currentInstanceName', this.instanceDataService.instanceDetails.name);
            // localStorage.setItem('currentInstanceName', instance.name);
            localStorage.setItem('currentInstanceTypeName', this.instanceDataService.instanceDetails.instanceType.name);
            localStorage.setItem('currentInstanceId', this.instanceDataService.instanceDetails.instanceId);
            localStorage.setItem('selectedInstanceDetails', JSON.stringify(this.instanceDataService.instanceDetails));
            if (
                this.instanceDataService.instanceDetails &&
                this.instanceDataService.instanceDetails.instanceAssetType &&
                this.instanceDataService.instanceDetails.instanceAssetType.name
            ) {
                localStorage.setItem('currentAssetType', this.instanceDataService.instanceDetails.instanceAssetType.name);
            }
            if (localStorage.getItem('selectedURL') == null || localStorage.getItem('selectedURL') == '') {
                this.navigateUrlService.getInstancesByOrgId(localStorage.getItem('selectedOrgId'), this.instanceDataService.instanceDetails.name);
            } else {
                const selectedURL = localStorage.getItem('selectedURL');
                this.navigateUrlService.navigateUrl(selectedURL);
            }
        }
    }

    selectAllToggle() {
        this.isModified = true;
    }

    navigateBack() {
        if (this.isInformateInstance) {
            this.instanceDataService.instanceNavigationHandler(5);
        } else {
            this.instanceDataService.instanceNavigationHandler(19);
        }
    }

    clickCancel() {
        let dialogRef = this.ngbModal.open(ConfirmationDialogComponent, {
            size: 'sm',
        });
        if (this.route.snapshot.paramMap.get('id')) {
            dialogRef.componentInstance.modalMessage = 'Your changes are not saved. Are you sure you want to go back?';
        } else {
            dialogRef.componentInstance.modalMessage = 'Your Instance details are not saved. Are you sure you want to go back?';
        }
        dialogRef.result.then((result) => {
            if (result === true) {
                if (this.isInformateInstance) {
                    this.instanceDataService.instanceNavigationHandler(5);
                } else {
                    this.instanceDataService.navigateThroughWizard.next(6);
                }
            }
        });
    }

    ngOnDestroy() {
        this.destroy$.next(null);
        this.destroy$.complete();
    }
}
